import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "header-component" }
const _hoisted_2 = { class: "header-root__container" }
const _hoisted_3 = { class: "header-root__container__item" }
const _hoisted_4 = { class: "header-root__container__item" }
const _hoisted_5 = { class: "header-root__container__item" }
const _hoisted_6 = {
  class: "header-root__container__item",
  style: {"margin-right":"unset"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          id: "main-describe",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onHeaderButClick && _ctx.onHeaderButClick(...args))),
          class: "header_button"
        }, " О студии ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          id: "student-works",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHeaderButClick && _ctx.onHeaderButClick(...args))),
          class: "header_button"
        }, " Работы ")
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "header-root__container__item logo" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          id: "master-class",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onHeaderButClick && _ctx.onHeaderButClick(...args))),
          class: "header_button"
        }, " Услуги ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          id: "address",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onHeaderButClick && _ctx.onHeaderButClick(...args))),
          class: "header_button"
        }, " Контакты ")
      ])
    ])
  ]))
}